import React, { createContext, useContext, useState } from "react";
import { IShowUserMenuContext } from "../exports/interfaces";

const ShowUserMenuContext = createContext<IShowUserMenuContext>({
  showUserMenu: true,
  setShowUserMenu: () => null,
});
export const useShowUserMenu = () => useContext(ShowUserMenuContext);

export const ShowUserMenuProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [showUserMenu, setShowUserMenu] = useState<boolean>(false);

  return (
    <ShowUserMenuContext.Provider value={{ showUserMenu, setShowUserMenu }}>
      {children}
    </ShowUserMenuContext.Provider>
  );
};
